import { NgModule } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  SharedModule,
  InputModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  DaterangepickerModule,
  AutocompleteModule,
  ComboModule,
} from 'beyond-util';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ReportHeaderModule } from '../../../components/report-header/report-header.module';
import { IzvestajZaOfpsComponent } from './izvestaj-za-ofps.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    ReportHeaderModule,
    DaterangepickerModule,
    AutocompleteModule,
    ComboModule,
    InputModule,
    SharedModule,
    NgxSpinnerModule,
  ],
  declarations: [IzvestajZaOfpsComponent],
  exports: [IzvestajZaOfpsComponent],
  entryComponents: [IzvestajZaOfpsComponent],
})
export class IzvestajZaOfpsModule {}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-ofps/izvestaj-za-ofps.module.ts